import { defineComponent as _defineComponent } from 'vue';
import { DialogTrigger } from "reka-ui";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SheetTrigger',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get DialogTrigger() { return DialogTrigger; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
